// extracted by mini-css-extract-plugin
export default {"heading-primary":"SemanticCheckbox_heading-primary__2jyDE","checkbox-input":"SemanticCheckbox_checkbox-input__5cCyh","checked":"SemanticCheckbox_checked__bdRQo"};